import {
  type ResultOf,
  type VariablesOf,
} from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const document = graphql(`
  mutation BrandListPage_UpdateBrand(
    $brandId: Int!
    $name: String!
    $brandNumber: Int!
  ) {
    updateBrand(brandId: $brandId, name: $name, number: $brandNumber) {
      id
      name
      number
    }
  }
`)
type Data = ResultOf<typeof document>
type Variables = VariablesOf<typeof document>

export const useUpdateBrandMutation = (
  options: Omit<
    UseMutationOptions<Data, unknown, Variables, unknown>,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()

  return useMutation({
    mutationFn: (variables) => graphQLRequest({ document, variables }),
    ...options,
  })
}
